export const USER_ACTIVITIES = {
  LOGGED_IN: { value: 'LOGGED_IN', display: 'Logged In', description: 'User has logged in.' },
  SIGNED_UP: { value: 'SIGNED_UP', display: 'Signed Up', description: 'User has signed up.' },
  LOGGED_OUT: { value: 'LOGGED_OUT', display: 'Logged Out', description: 'User has logged out.' },
};
export type USER_ACTIVITY = keyof typeof USER_ACTIVITIES;
